import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { supabase } from '../../supabaseClient';

export function OAuthCallbackPage() {
    const history = useHistory();
    const { loading } = useAuth();

    useEffect(() => {
        if (loading) return undefined;

        let cancelled = false;

        const finishSignIn = async () => {
            const url = new URL(window.location.href);
            const code = url.searchParams.get('code');
            const queryError = url.searchParams.get('error_description') || url.searchParams.get('error');

            // Some providers return OAuth errors in the URL hash as well as query params.
            let hashError = '';
            if (window.location.hash && window.location.hash.length > 1) {
                const hashParams = new URLSearchParams(window.location.hash.slice(1));
                hashError = hashParams.get('error_description') || hashParams.get('error') || '';
            }

            const oauthError = queryError || hashError;

            try {
                if (oauthError) {
                    if (!cancelled) {
                        history.replace(`/login?oauthError=${encodeURIComponent(oauthError)}`);
                    }
                    return;
                }

                if (code) {
                    await supabase.auth.exchangeCodeForSession(code);
                }

                const result = await supabase.auth.getSession();
                const session = result?.data?.session || null;

                if (cancelled) return;

                if (session?.user) {
                    let storedReturnUrl = '';
                    try {
                        storedReturnUrl = sessionStorage.getItem('regatta.oauth.returnUrl') || '';
                        sessionStorage.removeItem('regatta.oauth.returnUrl');
                    } catch {
                        storedReturnUrl = '';
                    }

                    const destination = storedReturnUrl && storedReturnUrl.startsWith('/') ? storedReturnUrl : '/select-meeting';
                    history.replace(destination);
                    return;
                }
            } catch {
                // Fall through to login redirect.
            }

            if (!cancelled) {
                history.replace('/login');
            }
        };

        finishSignIn();

        return () => {
            cancelled = true;
        };
    }, [history, loading]);

    return (
        <div className="py-4" style={{ maxWidth: '420px' }}>
            <h3 className="mb-3">Completing Sign-In</h3>
            <p className="text-muted mb-0">Completing your sign-in...</p>
        </div>
    );
}
